// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__3d5_Y","icon":"SortAdornment_icon__YG6HF","up":"SortAdornment_up__3qGU7","down":"SortAdornment_down__n0IJQ","active":"SortAdornment_active__3WBWr"};